import React from 'react';
import '../styles/AboutUsPage.css'; // Make sure this path is correct

const AboutUsPage = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About DKL Books</h1>

      <p className="about-intro">
        DKL Books is a Toronto-based online bookstore dedicated to bringing authentic Nepali literature to the Nepali community in Canada.
      </p>

      <p>
        Founded in 2026, we saw a growing need among Nepali Canadians — students, professionals, and families — to stay connected to their literary heritage while living abroad.
      </p>

      <p>
        We specialize in Nepali novels, poetry, classics, and contemporary works by renowned authors like Laxmi Prasad Devkota, Narayan Wagle, Parijat, and many emerging voices.
      </p>

      <h2 className="about-subtitle">Our Mission</h2>
      <p>
        To preserve and promote Nepali language and culture through accessible, high-quality books delivered across Canada.
      </p>

      <h2 className="about-subtitle">Why Choose Us?</h2>
      <ul className="about-list">
        <li>Curated collection of authentic Nepali books</li>
        <li>Fast delivery to Toronto and nationwide</li>
        <li>Support local and Nepali authors</li>
        <li>Secure shopping and excellent customer service</li>
      </ul>

      <p className="about-quote">
        "A book is a bridge between cultures." — We believe in building that bridge, one story at a time.
      </p>
    </div>
  );
};

export default AboutUsPage;
